import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { authApi } from '../../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function ProfileModal({ onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {} finally {
      logout();
      navigate('/login');
      toast.info('Signed out');
    }
  };

  return (
    <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-box" style={{ maxWidth: 500 }}>
        <div className="modal-header">
          <span className="modal-title">User Profile</span>
          <button className="btn-icon" onClick={onClose}>✕</button>
        </div>
        
        <div className="modal-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div className="user-avatar" style={{ width: 64, height: 64, fontSize: '1.5rem', flexShrink: 0 }}>
              {(user?.firstName?.[0] || user?.username?.[0] || 'U').toUpperCase()}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '1.25rem', fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user?.fullName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'User'}
              </div>
              <div style={{ color: 'var(--text-muted)' }}>@{user?.username}</div>
            </div>
          </div>
          
          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <label className="form-label">First Name</label>
              <div className="form-input" style={{ background: 'var(--input-bg)', opacity: 0.8, cursor: 'default' }}>{user?.firstName || '-'}</div>
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label">Last Name</label>
              <div className="form-input" style={{ background: 'var(--input-bg)', opacity: 0.8, cursor: 'default' }}>{user?.lastName || '-'}</div>
            </div>
            <div className="col-12">
              <label className="form-label">Email Address</label>
              <div className="form-input" style={{ background: 'var(--input-bg)', opacity: 0.8, cursor: 'default' }}>{user?.email || '-'}</div>
            </div>
            <div className="col-12">
              <label className="form-label">Mobile Number</label>
              <div className="form-input" style={{ background: 'var(--input-bg)', opacity: 0.8, cursor: 'default' }}>{user?.phoneNumber || '-'}</div>
            </div>
          </div>
        </div>

        <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
          {/* Using btn-ghost to match the boundary of the Close button, but with red accents */}
          <button 
            className="btn-ghost" 
            onClick={handleLogout}
            style={{ borderColor: '#dc3545', color: '#dc3545' }}
          >
            Log out
          </button>
          <button className="btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}